var _path, _path2, _path3, _circle, _path4, _ellipse, _path5, _path6, _path7, _path8, _circle2, _ellipse2, _path9, _path10, _path11, _path12, _circle3, _rect, _rect2, _rect3, _rect4, _path13, _path14, _rect5, _path15, _path16, _path17, _circle4, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConfeti(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 251,
    viewBox: "0 0 228 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200.586 167.322C202.57 175.862 210.724 192.35 227.473 189.978",
    stroke: "#72F06F",
    strokeWidth: 2.75814
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M186.021 145.062C186.021 181.162 154.667 210.426 115.989 210.426C77.3115 210.426 45.957 181.162 45.957 145.062C45.957 108.963 77.3115 79.699 115.989 79.699C154.667 79.699 186.021 108.963 186.021 145.062Z",
    fill: "url(#paint0_linear_1955_543)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M110.283 65.1738H120.658V81.774H110.283V65.1738Z",
    fill: "url(#paint1_linear_1955_543)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 115.47,
    cy: 52.7225,
    r: 14.5252,
    fill: "#000F20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.509 215.613C157.765 215.613 191.21 184.491 191.21 146.1C191.21 122.887 178.983 102.333 160.196 89.7073C158.452 88.535 156.378 87.9717 154.276 87.9717H78.7408C76.639 87.9717 74.5654 88.535 72.821 89.7073C54.034 102.333 41.8076 122.887 41.8076 146.1C41.8076 184.491 75.2524 215.613 116.509 215.613Z",
    fill: "url(#paint2_linear_1955_543)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 63.3465,
    cy: 190.682,
    rx: 5.49283,
    ry: 10.2991,
    transform: "rotate(-44.9872 63.3465 190.682)",
    fill: "#236DC1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.8594 200.927C77.6745 198.07 75.324 191.19 69.6096 185.56C63.8951 179.93 56.9806 177.682 54.1655 180.539C51.3505 183.396 53.7009 190.276 59.4154 195.907C65.1298 201.537 72.0444 203.785 74.8594 200.927ZM69.9501 197.264C71.7413 195.446 70.2457 191.068 66.6097 187.486C62.9736 183.903 58.5739 182.473 56.7828 184.291C54.9916 186.109 56.4871 190.487 60.1232 194.069C63.7592 197.652 68.1589 199.082 69.9501 197.264Z",
    fill: "#468BDC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6997 193.099L70.9086 189.023L62.7564 182.606L59.5476 186.682L67.6997 193.099ZM50.3566 198.493L51.374 203.58L50.3566 198.493ZM39.3822 187.47C38.0455 184.936 34.9075 183.966 32.3735 185.302C29.8395 186.639 28.8689 189.777 30.2057 192.311L39.3822 187.47ZM59.5476 186.682C56.6985 190.301 54.6084 191.739 53.2889 192.383C51.8823 193.069 51.1863 193.037 49.3393 193.406L51.374 203.58C52.1208 203.43 54.8592 203.161 57.8382 201.707C60.9044 200.211 64.1509 197.607 67.6997 193.099L59.5476 186.682ZM49.3393 193.406C49.5995 193.354 49.25 193.464 48.0422 193.089C46.9824 192.761 45.6986 192.195 44.3788 191.451C43.0657 190.712 41.8456 189.868 40.8917 189.057C40.4176 188.653 40.0468 188.29 39.7766 187.985C39.6434 187.834 39.5461 187.711 39.4781 187.616C39.4447 187.57 39.4208 187.534 39.4046 187.508C39.3884 187.482 39.3818 187.469 39.3822 187.47L30.2057 192.311C31.1724 194.144 32.7224 195.729 34.1695 196.96C35.6945 198.257 37.4748 199.47 39.286 200.491C41.0905 201.507 43.0548 202.405 44.9691 202.999C46.7353 203.547 49.0858 204.037 51.374 203.58L49.3393 193.406Z",
    fill: "#000F20"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6603 193.148L70.9179 189.111L62.8437 182.595L59.586 186.633L67.6603 193.148ZM53.469 197.974L51.6962 193.099L53.469 197.974ZM40.101 185.603C38.9991 182.959 35.9619 181.708 33.3173 182.81C30.6727 183.912 29.422 186.949 30.524 189.594L40.101 185.603ZM30.524 189.594C30.7872 190.226 31.0905 190.835 31.4227 191.419L40.4407 186.288C40.2988 186.039 40.1871 185.81 40.101 185.603L30.524 189.594ZM52.8249 203.444C53.6263 203.332 54.4386 203.141 55.2418 202.849L51.6962 193.099C51.6385 193.12 51.5426 193.147 51.3984 193.167L52.8249 203.444ZM55.2418 202.849C55.4965 202.756 55.7332 202.673 55.9539 202.597L52.5783 192.786C52.3022 192.881 52.0088 192.985 51.6962 193.099L55.2418 202.849ZM67.1408 193.793C67.3073 193.586 67.4803 193.371 67.6603 193.148L59.586 186.633C59.3998 186.863 59.2208 187.086 59.0487 187.3L67.1408 193.793Z",
    fill: "#0F4688"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.4336 191.966C73.3318 189.835 71.6946 187.614 69.6096 185.56C66.376 182.374 62.7582 180.271 59.7163 179.563L60.9999 183.862C62.7793 184.439 64.7901 185.693 66.6097 187.486C68.0687 188.923 69.183 190.489 69.8787 191.966H74.4336Z",
    fill: "#468BDC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.2218,
    cy: 180.913,
    r: 11.0236,
    transform: "rotate(-30.6263 31.2218 180.913)",
    fill: "#85B7F2"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.49283,
    cy: 10.2991,
    rx: 5.49283,
    ry: 10.2991,
    transform: "matrix(-0.875304 -0.483572 -0.483572 0.875304 193.475 169.521)",
    fill: "#236DC1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.459 188.911C171.964 186.944 172.318 179.682 176.251 172.69C180.184 165.699 186.206 161.625 189.702 163.591C193.198 165.558 192.843 172.82 188.91 179.812C184.978 186.803 178.955 190.877 175.459 188.911ZM179.163 184.032C176.939 182.781 177.164 178.16 179.667 173.711C182.169 169.262 186.001 166.67 188.225 167.921C190.45 169.173 190.224 173.793 187.722 178.242C185.219 182.691 181.387 185.283 179.163 184.032Z",
    fill: "#468BDC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M180.171 179.408L175.96 176.379L182.017 167.956L186.229 170.985L180.171 179.408ZM198.33 179.791L198.76 184.96L198.33 179.791ZM205.824 166.161C206.408 163.356 209.154 161.555 211.959 162.138C214.764 162.721 216.565 165.468 215.982 168.273L205.824 166.161ZM186.229 170.985C189.968 173.674 192.375 174.477 193.821 174.731C195.362 175.001 196.022 174.777 197.899 174.621L198.76 184.96C198.001 185.023 195.295 185.522 192.03 184.95C188.67 184.361 184.829 182.758 180.171 179.408L186.229 170.985ZM197.899 174.621C197.635 174.643 198.001 174.652 199.058 173.957C199.985 173.348 201.063 172.449 202.125 171.37C203.182 170.295 204.121 169.147 204.813 168.103C205.157 167.585 205.413 167.133 205.588 166.764C205.674 166.583 205.733 166.437 205.773 166.328C205.792 166.274 205.805 166.232 205.813 166.203C205.822 166.174 205.825 166.16 205.824 166.161L215.982 168.273C215.561 170.301 214.51 172.254 213.46 173.837C212.354 175.505 210.979 177.164 209.521 178.646C208.068 180.122 206.429 181.529 204.754 182.629C203.208 183.645 201.085 184.767 198.76 184.96L197.899 174.621Z",
    fill: "#000F20"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M180.224 179.443L175.977 176.465L181.932 167.97L186.18 170.947L180.224 179.443ZM195.197 180.152L195.551 174.977L195.197 180.152ZM204.619 164.565C204.946 161.719 207.518 159.677 210.364 160.004C213.211 160.33 215.253 162.903 214.926 165.749L204.619 164.565ZM214.926 165.749C214.848 166.429 214.725 167.098 214.568 167.751L204.482 165.317C204.549 165.039 204.593 164.788 204.619 164.565L214.926 165.749ZM197.33 185.23C196.529 185.345 195.695 185.386 194.843 185.328L195.551 174.977C195.612 174.981 195.712 174.981 195.856 174.96L197.33 185.23ZM194.843 185.328C194.572 185.309 194.322 185.295 194.089 185.283L194.617 174.921C194.909 174.936 195.219 174.954 195.551 174.977L194.843 185.328ZM180.902 179.92C180.685 179.766 180.459 179.607 180.224 179.443L186.18 170.947C186.423 171.118 186.656 171.282 186.881 171.44L180.902 179.92Z",
    fill: "#0F4688"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.388 180.181C173.857 177.829 174.816 175.242 176.251 172.69C178.476 168.734 181.371 165.712 184.098 164.19L184.054 168.676C182.504 169.723 180.919 171.485 179.667 173.711C178.662 175.496 178.025 177.309 177.765 178.921L173.388 180.181Z",
    fill: "#468BDC"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.0236,
    cy: 11.0236,
    r: 11.0236,
    transform: "matrix(-0.967893 -0.251362 -0.251362 0.967893 225.292 149.701)",
    fill: "#85B7F2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 111.571,
    y: 187.599,
    width: 1.55627,
    height: 10.8939,
    rx: 0.778135,
    fill: "#5998E1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 120.909,
    y: 187.599,
    width: 1.55627,
    height: 10.8939,
    rx: 0.778135,
    fill: "#5998E1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 116.241,
    y: 184.486,
    width: 1.55627,
    height: 18.6752,
    rx: 0.778135,
    fill: "#5998E1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 56.5842,
    y: 106.673,
    width: 120.352,
    height: 63.2883,
    rx: 31.6442,
    fill: "#000F20",
    stroke: "#458DDE",
    strokeWidth: 4.15005
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M102.235 134.686C102.235 133.323 101.966 131.974 101.445 130.715C100.923 129.457 100.159 128.313 99.1958 127.349C98.2324 126.386 97.0887 125.622 95.8299 125.1C94.5711 124.579 93.222 124.311 91.8595 124.311C90.497 124.311 89.1479 124.579 87.8891 125.1C86.6303 125.622 85.4866 126.386 84.5232 127.349C83.5598 128.313 82.7955 129.457 82.2741 130.715C81.7527 131.974 81.4844 133.323 81.4844 134.686",
    stroke: "#72B2FF",
    strokeWidth: 5.18757,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M154.11 134.686C154.11 133.323 153.841 131.974 153.32 130.715C152.798 129.457 152.034 128.313 151.071 127.349C150.107 126.386 148.964 125.622 147.705 125.1C146.446 124.579 145.097 124.311 143.735 124.311C142.372 124.311 141.023 124.579 139.764 125.1C138.505 125.622 137.362 126.386 136.398 127.349C135.435 128.313 134.671 129.457 134.149 130.715C133.628 131.974 133.359 133.323 133.359 134.686",
    stroke: "#72B2FF",
    strokeWidth: 5.18757,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 125.343,
    y: 204.103,
    width: 17.4682,
    height: 3.67752,
    transform: "rotate(52.1405 125.343 204.103)",
    fill: "#EBA149"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5852 64.907C47.7141 66.4668 48.8888 64.907 54.2722 65.4949",
    stroke: "#63A5F0",
    strokeWidth: 6.43566
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M117.474 191.231L126.828 203.752L121.06 208.24C121.06 208.24 119.523 206.741 119.221 205.482C118.978 204.47 119.681 202.264 118.761 201.345C117.842 200.425 116.272 198.586 116.272 198.586L116.272 195.369L116.272 192.151L117.474 191.231Z",
    fill: "#F6DA76"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M124.938 200.967L127.018 203.752L121.06 208.239L119.68 206.401L119.221 205.482L119.221 205.022L124.938 200.967Z",
    fill: "#EBC749"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 138.988,
    cy: 216.054,
    r: 7.35504,
    fill: "#EBA049"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M132.093 212.837C133.778 216.055 137.885 221.663 140.827 218.353C144.504 214.216 139.908 212.377 138.988 212.837C138.069 213.296 135.311 215.135 137.149 216.514C138.62 217.617 139.601 216.361 139.908 215.595",
    stroke: "#D3852A",
    strokeWidth: 0.919381
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M208.621 122.077C212.6 125.67 214 122.077 218.949 127.579",
    stroke: "#63A5F0",
    strokeWidth: 6.43566
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M117.996 1.3391L147.631 86.569L82.3836 84.2496L117.996 1.3391Z",
    fill: "#FCE07E"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1485 63.8619L140.345 65.6107L143.865 75.8554L86.8995 73.8304L91.1485 63.8619Z",
    fill: "#C47FEF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M101.249 40.3026L131.907 41.3924L135.527 51.6407L96.9376 50.2689L101.249 40.3026Z",
    fill: "#C47FEF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M112.931 13.1187L122.205 13.4484L125.776 23.6949L108.656 23.0863L112.931 13.1187Z",
    fill: "#C47FEF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M140.734 86.3237L147.625 86.5686L117.996 1.33892L114.486 9.49381L140.734 86.3237Z",
    fill: "#201919",
    fillOpacity: 0.14
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9277 110.71C28.6619 109.944 46.1301 104.182 46.1301 87.2656",
    stroke: "#72F06F",
    strokeWidth: 2.75814
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M2 141.969C6.5969 139.211 8.43566 139.67 10.2744 133.694",
    stroke: "#63A5F0",
    strokeWidth: 6.43566
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M175.763 73.1993C180.526 80.5603 187.425 86.88 204.434 88.7187",
    stroke: "#FF9154",
    strokeWidth: 2.75814
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M7.97593 229.77C16.3406 227.142 19.4274 231.422 25.7356 215.52",
    stroke: "#FF9154",
    strokeWidth: 2.75814
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1955_543",
    x1: 115.989,
    y1: 65.1738,
    x2: 115.989,
    y2: 210.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58A1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#7E9DC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1955_543",
    x1: 115.989,
    y1: 65.1738,
    x2: 115.989,
    y2: 210.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58A1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#7E9DC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1955_543",
    x1: 116.509,
    y1: 76.5862,
    x2: 116.509,
    y2: 215.613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4CEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83B5F1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfeti);
export default __webpack_public_path__ + "static/media/confeti.8ac04903258f6b99be258a78d44ebb25.svg";
export { ForwardRef as ReactComponent };